import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { DefaultTheme } from 'styled-components';
import { defaultState, AppStateFields } from './data/AppRecord';
import * as appActions from './actions';

export const initializeApp = createAction<
  (
    doSetTokenAndProvider?: boolean,
    redirectUrl?: string | null,
    pathname?: string | null
  ) => {
    payload: {
      doSetTokenAndProvider: boolean;
      redirectUrl: string | null;
      pathname: string | null;
    };
  }
>('app/initializeApp', (doSetTokenAndProvider = true, redirectUrl = null, pathname = null) => ({
  payload: {
    doSetTokenAndProvider,
    redirectUrl,
    pathname,
  },
}));

function getInitialState(): AppStateFields {
  const timestamp = process.env.BUILD_TIMESTAMP;
  return {
    ...defaultState,
    timestamp,
  };
}

const fixedDefaultState = getInitialState();
const slice = createSlice({
  name: 'app',
  initialState: fixedDefaultState,
  reducers: {
    setShowOldVersionWarning: (state, action: PayloadAction<boolean>) => {
      state.showOldVersionWarning = action.payload;
    },
    setInitializingApp: (state, action: PayloadAction<boolean>) => {
      state.isInitializingApp = action.payload;
    },
    setAnalyticsReported: (state) => {
      state.analyticsReported = true;
    },
    setTheme: (state, action: PayloadAction<{ theme: DefaultTheme; isLightTheme: boolean }>) => {
      state.isLightTheme = action.payload.isLightTheme;
      state.theme = action.payload.theme;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appActions.updateWsReconnectionTime.type, (state) => {
      state.wsReconnectionDate = new Date();
    });
  },
});

export const { setShowOldVersionWarning, setInitializingApp, setAnalyticsReported, setTheme } =
  slice.actions;
export default slice.reducer;
